var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_footer"},[_c('span',[_vm._v(" Copyright © 2021 IROOTECH. All rights reserved. 树根互联 版权所有 粤ICP备19026860号-1 ")])])}]

export { render, staticRenderFns }